import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import DescriptionIcon from '@mui/icons-material/Description';
import EventIcon from '@mui/icons-material/Event';

import { WizardStep } from 'components/shared/WizardStepper';

export type EQEStepSlug = 'personal-details' | 'event-info' | 'dependents' | 'benefits' | 'summary';

const wizardSteps: Map<EQEStepSlug, WizardStep> = new Map([
  [
    'personal-details',
    {
      label: 'Personal Details',
      icon: PersonOutlineIcon,
      slug: 'personal-details',
      next: 'event-info',
    },
  ],
  [
    'event-info',
    {
      label: 'Event Info',
      icon: EventIcon,
      slug: 'event-info',
      next: 'dependents',
      prev: 'personal-details',
    },
  ],
  [
    'dependents',
    {
      label: 'Dependents',
      icon: PeopleOutlineIcon,
      slug: 'dependents',
      next: 'benefits',
      prev: 'event-info',
    },
  ],
  [
    'benefits',
    {
      label: 'Benefits',
      icon: LocalHospitalIcon,
      slug: 'benefits',
      next: 'summary',
      prev: 'dependents',
    },
  ],
  [
    'summary',
    {
      label: 'Summary',
      icon: DescriptionIcon,
      slug: 'summary',
      prev: 'benefits',
    },
  ],
]);

export default wizardSteps;
